const FOOT_LINKS = [
  { title: "内容分区", items: ["圈子内幕", "好友八卦", "行业爆料", "幕后闹剧", "三观炸裂", "饭圈谈资"] },
  { title: "关于我们", items: ["编辑部来信", "加入吃瓜观察员", "线索投稿", "版权与合作"] },
  { title: "社区规范", items: ["发言公约", "不传谣声明", "投诉通道", "未成年提醒"] },
];

export default function SiteFooter() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <p className="font-heading text-3xl font-black tracking-[0.14em] text-background-50">
              成人吃瓜
            </p>
            <p className="mt-4 max-w-sm font-heading text-sm leading-relaxed text-background-100/70">
              成人吃瓜圈子内幕、好友八卦、行业爆料与幕后闹剧的长期记录者。吃得清醒，看得通透，三观炸裂但记得回魂。
            </p>
            <div className="mt-5 flex items-center gap-2 text-xs text-background-100/60">
              <span className="flex h-2 w-2">
                <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-400"></span>
              </span>
              成人吃瓜圈子内幕持续更新中 · 更新于今日
            </div>
          </div>

          {FOOT_LINKS.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <h4 className="text-sm font-bold tracking-widest text-background-50">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.items.map((it) => (
                  <li key={it}>
                    <a
                      href="#headline"
                      className="text-sm text-background-100/75 transition-colors hover:text-primary-300"
                    >
                      {it}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-1" />
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-100/15 pt-6 text-xs text-background-100/60 sm:flex-row sm:items-center sm:justify-between">
          <p>
            © 2026 成人吃瓜 · 本站为静态内容演示页，文中人物与事件均为虚构，仅供娱乐，请理性吃瓜。
          </p>
          <div className="flex items-center gap-4">
            <a href="#headline" className="hover:text-primary-300">返回顶部</a>
            <span className="flex items-center gap-1.5">
              <i className="ri-shield-check-line" aria-hidden="true"></i>
              内容风险提示
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}